import React from 'react'
import PropTypes from 'prop-types'

import Recommendation from '../Recommendation/Recommendation'
import { AccordionItem, AccordionTrigger, AccordionContent } from '../../ui/accordion'

function RecommendationLevelCard({ recommendations = [] }) {
  if (!recommendations.length) return null
  const levelName = recommendations[0].skillLevel.name
  const levelId = recommendations[0].skillLevel.id
  return (
    <AccordionItem
      value={`level-${levelId}`}
      className="mx-1 bg-white shadow rounded-xl border-none"
      data-cy={`recommendation-level-card-for-${levelName}`}
    >
      <AccordionTrigger className="px-5 hover:no-underline">
        <span className="text-lg font-medium text-gray-900">{levelName} Recommendations</span>
      </AccordionTrigger>
      <AccordionContent>
        {recommendations.map(({ id, skill, count, status }) => (
          <Recommendation key={id} shortLabel={skill.shortLabel} name={skill.name} studentCount={count} status={status} />
        ))}
      </AccordionContent>
    </AccordionItem>
  )
}

RecommendationLevelCard.propTypes = {
  recommendations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      count: PropTypes.number.isRequired,
      skill: PropTypes.shape({
        shortLabel: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired,
      skillLevel: PropTypes.shape({
        name: PropTypes.string.isRequired
      }).isRequired,
      status: PropTypes.oneOf(['unintroduced', 'introduced']).isRequired
    })
  )
}

export default RecommendationLevelCard
